import styled from '@emotion/styled'
import { colors } from '../constants'
import { Text } from '../typography'
import { AlertKind } from './Alert'

interface IContainerProps {
  kind: AlertKind
}

export const Container = styled.div<IContainerProps>`
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: ${({ kind }) => colors.alert.background[kind]};
`

interface IMessageProps {
  kind: AlertKind
}

export const Message = styled(Text)<IMessageProps>`
  padding-right: 30px;
  color: ${({ kind }) => colors.alert.message[kind]};
`

interface IDismissProps {
  kind: AlertKind
}

export const Dismiss = styled(Text)<IDismissProps>`
  cursor: pointer;
  color: ${({ kind }) => colors.alert.dismiss[kind]};
`

interface IExpandableContainerProps {
  kind: AlertKind
}

export const ExpandableContainer = styled.div<IExpandableContainerProps>`
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  padding: 12px 15px;
  background-color: ${({ kind }) => colors.alert.background[kind]};
`

interface IExpandableMessageProps {
  kind: AlertKind
  isExpanded: boolean
}

export const ExpandableMessage = styled(Text)<IExpandableMessageProps>`
  color: ${({ kind }) => colors.alert.message[kind]};
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-wrap: break-word;
  hyphens: auto;

  ${({ isExpanded }) =>
    !isExpanded &&
    `
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
  `}

  @media (max-width: 768px) {
    line-height: 1.5;
  }
`

interface IToggleButtonProps {
  kind: AlertKind
}

export const ToggleButton = styled.span<IToggleButtonProps>`
  cursor: pointer;
  color: ${({ kind }) => colors.alert.message[kind]};
  font-family: 'Moderat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 600;
  line-height: 24px;
  margin-top: 8px;
  padding: 2px 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  align-self: flex-start;
  outline: none;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
    background-color: rgba(0, 0, 0, 0.05);
  }

  &:focus {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
    background-color: rgba(0, 95, 204, 0.1);
  }

  &:focus:not(:focus-visible) {
    outline: none;
    background-color: transparent;
  }

  &:focus-visible {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
    background-color: rgba(0, 95, 204, 0.1);
  }

  svg {
    vertical-align: middle;
    margin-left: 2px;
  }

  @media (max-width: 768px) {
    padding: 4px 6px;
  }
`
